import * as t from 'io-ts';

export const publicIdDecoded = t.type({
  id: t.number,
});
